export const CONFIG = {
  MIN_DATE: '2019-01-01',
  MONTH_PASS: -6
};
